import React from 'react';
import { Construction, Clock, Mail } from 'lucide-react';

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* Logo/Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-red-500 to-red-700 rounded-full flex items-center justify-center shadow-lg">
            <Construction className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
          Вкусът на Турция
        </h1>

        {/* Subtitle */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-amber-100">
          <div className="flex items-center justify-center gap-2 text-amber-600 mb-4">
            <Clock className="w-5 h-5" />
            <span className="text-sm font-medium uppercase tracking-wider">Скоро отваряме</span>
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Сайтът е в процес на подготовка
          </h2>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Работим усилено, за да ви предложим най-добрите турски деликатеси. 
            Очаквайте ни съвсем скоро с богат асортимент от автентични продукти!
          </p>

          {/* Contact */}
          <div className="pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500 mb-2">За въпроси се свържете с нас:</p>
            <a 
              href="mailto:vkustnaturcia39@gmail.com" 
              className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-medium transition-colors"
            >
              <Mail className="w-4 h-4" />
              vkustnaturcia39@gmail.com
            </a>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="mt-8 flex justify-center gap-2">
          <div className="w-2 h-2 rounded-full bg-red-400 animate-pulse"></div>
          <div className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 rounded-full bg-red-400 animate-pulse" style={{ animationDelay: '0.4s' }}></div>
        </div>

        {/* Footer */}
        <p className="mt-8 text-xs text-gray-400">
          © 2024 ВКУСЪТ НА ТУРЦИЯ ЕООД (VKUSAT NA TURKEY EOOD). Всички права запазени.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceMode;
